module.exports = __webpack_public_path__ + "img/ui_admin_blue.e3d2192c.png";